export class UserDetail {
  name: string;
  email: string;
  id: string;
  lanid?: string;
  imageURL?: string;
  canMaintainSupplierProfile: boolean;
  canViewAdminPage: boolean;
  isLoaded: boolean = false;

  constructor(init?: Partial<UserDetail>) {
    Object.assign(this, init);
  }
}
